'use client'

import { Search } from 'lucide-react'
import { motion } from 'motion/react'
import { useState } from 'react'
import { SearchModalDialog } from '../../search-modal'

export function HomepageSearch() {
  const [isOpen, setIsOpen] = useState(false)

  return (
    <>
      <motion.button
        type='button'
        data-testid='global-search-input'
        layoutId='global-search'
        layout
        transition={{
          duration: 0.4,
          type: 'spring',
          stiffness: 300,
          damping: 30,
        }}
        onClick={() => setIsOpen(true)}
        className='flex items-center gap-3 w-full max-w-[36rem] h-14 px-5 bg-surface1 hover:bg-surface2 rounded-full text-secondary transition-colors cursor-pointer'
      >
        <Search className='size-4 shrink-0' />
        <span className='text-base'>Trade anything...</span>
      </motion.button>
      <SearchModalDialog
        isOpen={isOpen}
        open={() => setIsOpen(true)}
        close={() => setIsOpen(false)}
      />
    </>
  )
}
